// @flow

import ReactDOM from 'react-dom';

class CustomMarker extends global.google.maps.OverlayView {
  constructor(latlng, map, args) {
    super(latlng, map, args);
    this.latlng = latlng;
    this.args = args;
    this.setMap(map);
  }

  onAdd() {
    if (!this.container) {
      this.container = global.document.createElement('div');
      this.container.className = 'map__point center center--both';

      if (this.args.hasMouseEvents) {
        this.getPanes().floatPane.appendChild(this.container);
      } else {
        this.getPanes().overlayLayer.appendChild(this.container);
      }

      if (this.args.markup) {
        ReactDOM.render(this.args.markup, this.container);
      }
    }
  }

  draw() {
    if (this.container) {
      const point = this.getProjection().fromLatLngToDivPixel(this.latlng);

      if (point) {
        this.container.style.left = `${point.x}px`;
        this.container.style.top = `${point.y}px`;
      }
    }
  }

  onRemove() {
    if (this.container) {
      this.container.parentNode.removeChild(this.container);
      this.container = null;
    }
  }
}

export default CustomMarker;



// WEBPACK FOOTER //
// ./screens/App/screens/GMap/CustomMarker.js